/**
 * Hook to listen for market events via WebSocket
 * Shows toast notifications for item sales regardless of current page
 */

import { useSimpleWebSocketEvent } from './useWebSocketEvent'
import { useToast } from '../contexts/ToastContext'

export function useMarketNotifications(isAuthenticated = false) {
  const toast = useToast()

  useSimpleWebSocketEvent(
    'market.item.sold',
    (event) => {
      console.log('📦 Market item sold event received:', event)

      const eventData = event.data || event
      const itemName = eventData?.item_name || 'your item'
      const price = eventData?.price || 0

      // Show seller notification when their item sells
      toast.success(`🎉 ${itemName} has been sold for ${price} 🪙! Go to "My Listings" to collect your earnings.`, {
        duration: 6000
      })
    },
    isAuthenticated,
    [toast]
  )
}

export default useMarketNotifications
